"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSingleResponseQuestion = void 0;
function isSingleResponseQuestion(targetQuestion) {
    var _a;
    switch (targetQuestion.subType) {
        case "PARTICIPANT":
            return !((_a = targetQuestion.properties) === null || _a === void 0 ? void 0 : _a.allowMultipleAnswers);
        case "TEXT_LINE":
        case "TEXT_AREA":
        case "LOCATION":
        case "DROP_DOWN":
        case "RADIO_BUTTONS":
        case "RATING":
        case "YES_OR_NO":
        case "DATE":
        case "TIME":
        case "DATE_TIME":
            return true;
        case "MULTI_SELECT":
        case "CHECKBOX":
            return false;
        case "MAP_DRAW":
        case "DOCUMENT":
        case "PHOTO":
        case "DRAWING":
        case "HYPERLINK":
        case "BARCODE":
        default:
            throw new Error("Unhandled question type in prefill logic " + targetQuestion.subType);
    }
}
exports.isSingleResponseQuestion = isSingleResponseQuestion;
//# sourceMappingURL=isSingleResponseQuestion.js.map